import { Link } from "react-router-dom";

export default function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-logo" data-testid="legal-back-home">
            <span className="logo-teal">Your</span>Solicitor.co.uk
          </Link>
          <Link to="/" className="legal-back-btn" data-testid="legal-back-btn">
            &larr; Back to Home
          </Link>
        </div>
      </div>
      <div className="legal-hero">
        <div className="legal-hero-inner">
          <h1>{title}</h1>
          {lastUpdated && <p className="legal-updated">Last updated: {lastUpdated}</p>}
        </div>
      </div>
      <div className="legal-content">
        <div className="legal-content-inner">
          {children}
        </div>
      </div>
      <div className="legal-footer">
        <div className="legal-footer-inner">
          <p>&copy; 2026 YourSolicitor.co.uk. All Rights Reserved.</p>
          <div className="legal-footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/terms-of-engagement">Terms of Engagement</Link>
            <Link to="/complaints-procedure">Complaints Procedure</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
